var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeworkDetailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_13380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.90751 38.4277H37.5954C43.3526 38.4277 48 33.7803 48 28.0231V15.8843C48 11.5144 44.4624 7.97681 40.0925 7.97681H7.90751C3.53757 7.97681 0 11.5144 0 15.8843V30.5202C0.0693642 34.8901 3.60694 38.4277 7.90751 38.4277Z",
    fill: "#A6A7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.457 16.7168H34.6131V20.8093H13.457V16.7168ZM13.457 25.5954H30.9368V29.6879H13.457V25.5954Z",
    fill: "#8B8CC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2823 36.2774L9.08578 43.5607C8.25341 44.1849 7.07422 43.5607 7.07422 42.5202V34.8901L19.2823 36.2774Z",
    fill: "#A6A7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9127 10.5435L12.1382 3.3296C11.4445 1.45677 9.29423 0.555032 7.4214 1.24867C5.54856 1.94232 4.64683 4.0926 5.34047 5.96544L9.71041 17.2718C10.1266 18.3123 11.2364 18.7978 12.2769 18.3816C13.3174 17.9654 13.8029 16.8556 13.3867 15.8151L9.50232 5.89607",
    stroke: "#F7C6C8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_13380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 43.8382,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeworkDetailIcon);
export default __webpack_public_path__ + "static/media/homework-detail-icon.8305bb6c9ae09d31d1f1b5a0fe2542a5.svg";
export { ForwardRef as ReactComponent };